import React from 'react';
import { styled } from 'styled-components';
import { SSpanTitle } from '~/components/styles/styles';
//import { classic } from '~/themes/classic';

type IProps = {
  children: React.ReactNode;
  iconSrc?: string;
  title?: string;
  widthPortrait?: string;
  widthLandscape?: string;
  setMaxHeight?: boolean;
  customIconHeight?: string;
  customIconWidth?: string;
  customIconTop?: string;
  autoWidthLandscape?: boolean;
};

type TProps = IProps;

export function WrapperItem({
  iconSrc,
  children,
  title,
  widthLandscape,
  widthPortrait,
  setMaxHeight,
  customIconTop,
  customIconHeight,
  customIconWidth,
  autoWidthLandscape,
}: TProps) {
  return (
    <Container
      $widthLandscape={widthLandscape}
      $customIconHeight={customIconHeight}
      $setMaxHeight={setMaxHeight}
      $widthPortrait={widthPortrait}
      $withIcon={iconSrc ? true : false}
      $autoWidthLandscape={autoWidthLandscape}
    >
      <SSpanTitle>{title}</SSpanTitle>
      {children}
      {iconSrc && (
        <SDivIcon
          $customIconTop={customIconTop}
          $customHeight={customIconHeight}
          $customWidth={customIconWidth}
          src={iconSrc}
          alt=""
        />
      )}
    </Container>
  );
}

//
const Container = styled.div<{
  disabled?: boolean;
  $withIcon?: boolean;
  $widthLandscape?: string;
  $widthPortrait?: string;
  $setMaxHeight?: boolean;
  $customIconHeight?: string;
  $autoWidthLandscape?: boolean;
}>`
  display: flex;
  border-radius: 24px;
  flex-direction: column;
  cursor: auto;
  border: 3px solid #fff;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  padding: ${({ $withIcon, $customIconHeight }) => {
    if ($withIcon) {
      if ($customIconHeight) {
        return '60px 30px 30px 30px';
      }
      return '90px 30px 30px 30px';
    }
    return '30px';
  }};
  position: relative;
  max-height: 100%;
  width: ${({ $widthLandscape }) =>
    $widthLandscape ? $widthLandscape : '95%'};
  height: ${({ $setMaxHeight }) => ($setMaxHeight ? '100%' : 'auto')};

  @media screen and (max-height: 800px) {
    max-width: 95%;
  }

  @media screen and (max-width: 450px) {
    max-width: 95%;

    padding: ${({ $withIcon, $customIconHeight }) => {
      if ($withIcon) {
        if ($customIconHeight) {
          return '50px 20px 10px 20px';
        }
        return '70px 20px 10px 20px';
      }
      return '10px';
    }};
  }

  @media screen and (max-height: 415px) {
    padding: ${({ $withIcon, $customIconHeight }) => {
      if ($withIcon) {
        if ($customIconHeight) {
          return '50px 20px 10px 20px';
        }
        return '60px 20px 10px 20px';
      }
      return '10px 20px';
    }};
    width: 95%;
  }

  @media screen and (orientation: portrait) {
    width: ${({ $widthPortrait }) => ($widthPortrait ? $widthPortrait : '95%')};
    @media screen and (max-width: 450px) {
      width: 95%;
    }
  }
  @media screen and (orientation: landscape) {
    width: ${({ $autoWidthLandscape }) => $autoWidthLandscape && 'auto'};
  }
`;

const SDivIcon = styled.img<{
  $customHeight?: string;
  $customWidth?: string;
  $customIconTop?: string;
}>`
  position: absolute;
  object-fit: contain;
  top: ${({ $customHeight, $customIconTop }) => {
    if ($customIconTop) return $customIconTop;
    return $customHeight ? '-30%' : '-100px';
  }};
  left: 50%;
  height: ${({ $customHeight }) => ($customHeight ? $customHeight : '200px')};
  transform: translateX(-50%);
  width: ${({ $customWidth }) => ($customWidth ? $customWidth : '200px')};

  @media screen and (max-width: 450px) {
    top: ${({ $customHeight, $customIconTop }) => {
      if ($customIconTop) return $customIconTop;
      return $customHeight ? '-30%' : '-80px';
    }};

    height: ${({ $customHeight }) => ($customHeight ? $customHeight : '160px')};
    width: ${({ $customWidth }) => ($customWidth ? $customWidth : '160px')};
  }
  @media screen and (max-height: 450px) {
    top: ${({ $customHeight, $customIconTop }) => {
      if ($customIconTop) return $customIconTop;
      return $customHeight ? '-30%' : '-35px';
    }};

    height: ${({ $customHeight }) => ($customHeight ? $customHeight : '100px')};
    width: ${({ $customWidth }) => ($customWidth ? $customWidth : '100px')};
  }
  @media screen and (max-height: 800px) {
    max-width: 95%;
  }
`;
